import React from 'react'
import { Images } from "../theme"

const Projects = () => {
    return (
        <div style={{background: `#3C5E68`}}>
            <div className="fx fxdc fxjcc fxaic" 
            style={{
                margin: `0 auto`,
                maxWidth: 1200,
                padding: `2.05rem 1.05rem`,
            }}>
                        <h1 style={{color: `#fff`, marginBottom: `0`,}}>OUR PROJECTS</h1>
            <div className="pd15" style={{width: 100,}}>
            <div className="" style={{position: `relative`, width: 100, height: 500,}}>  
                    <div style={{
                        margin: `0`,
                        width: 350,
                        height: 350,
                        padding: `0`,
                        backgroundColor: `#3C5E68`,
                        borderRadius: `50%`,
                        border: `10px solid #37B0AA`,
                        fontSize: 0,
                        lineHeight: 0,
                        overflow: `hidden`,
                        backgroundSize: `cover`,
                        backgroundPosition: `center center`,
                        backgroundRepeat: `no-repeat`,
                        backgroundImage: `url(${Images.img12})`,
                        position: `absolute`,
                        left: `0%`,
                        top: `50%`,
                        transform: `translate(-130%, -50%)`,
                    }}></div>
                    <div style={{
                        margin: `0`,
                        width: 450,
                        height: 450,
                        padding: `0`,
                        backgroundColor: `#3C5E68`,
                        borderRadius: `50%`,
                        border: `10px solid #37B0AA`,
                        fontSize: 0,
                        lineHeight: 0,
                        overflow: `hidden`,
                        backgroundSize: `cover`,
                        backgroundPosition: `center center`,
                        backgroundRepeat: `no-repeat`,
                        backgroundImage: `url(${Images.img4})`,
                        zIndex: 3,
                        position: `absolute`,
                        left: `50%`,
                        top: `50%`,
                        transform: `translate(-50%, -50%)`,
                    }}></div>
                    <div style={{
                        margin: `0`,
                        width: 350,
                        height: 350,
                        padding: `0`,
                        backgroundColor: `#3C5E68`,
                        borderRadius: `50%`,
                        border: `10px solid #37B0AA`,
                        fontSize: 0,
                        lineHeight: 0,
                        overflow: `hidden`,
                        backgroundSize: `cover`,
                        backgroundPosition: `center center`,
                        backgroundRepeat: `no-repeat`,
                        backgroundImage: `url(${Images.img9})`,
                        position: `absolute`,
                        right: `0%`,
                        top: `50%`,
                        transform: `translate(130%, -50%)`,
                    }}></div>
            </div>
            </div>
            <h2 style={{color: `#fff`, margin: 0,}}>Seven Palms - Katani RD</h2>
                <div className="">
                    <div className="pd15">  
                        <p style={{
                // fontFamily: `'Oxygen', sans-serif`,
                fontFamily: `"Ubuntu", sans-serif`,
                // fontFamily: `"Consolas", "Courier New", "Courier"`,
                color: `#fff`,
                maxWidth: 600,
                textAlign: `center`,
                marginBottom: `0`,
            }}>
                This is our first-born of many more outstanding developments to come; inspired by Scandinavian architecture. 
                Scan Real Estate Ltd brings to Kenya a concept of design that is exotic yet inviting; you won’t feel out of place.
                        </p>
                </div>
                </div>

            </div>
          </div>


// {/* <Image alt="Seven Palms" filename="12.jpg" 
//               imgStyle={{
//                 borderRadius: `50%`,
//                 width: `100%`,
//                 margin: 0,
//               }}          
//           /> */}

        //   <Typed
        //   // strings={['Modern homes^1000\n `Scandinavian inspired` ^1000\n `architecture`']}
        //   // strings={[
        //   //       'Modern homes', 
        //   //       'Scandinavian inspired',
        //   //       'architecture'
        //   //   ]}
        //     strings={['Modern homes, <br />Scandinavian inspired <br />architecture.']}
        //       typeSpeed={40}
        //       startDelay={1200}
        //       showCursor={false}
        //       // backSpeed={30}
        //       // backDelay={400}
        //       // loopCount={2}
        //       // loop
        //       // smartBackspace={true}
        //       // cursorChar={'📌'}
        //       // contentType={'html'}
        //       // callback={() => (console.log ('baby girl'))}
        //   />


        // const title = node.frontmatter.title || node.fields.slug
        // // const veta = import veto from `../../content/blog/blog/${node.fields.slug}/${node.frontmatter.image}`;
        // // const veto = require(`../../content/blog${node.fields.slug}${node.frontmatter.image}`);
    
        // return (
        //   <Link className="hbdv w45 lft" to={node.fields.slug} key={node.fields.slug}
        //     style={{
        //         // background: `#1D4354`,
        //         // backgroundImage: `url("${veto}")`,
        //         // backgroundImage: `url("../../content/blog/${node.fields.slug}/${node.frontmatter.image}")`,
        //         backgroundImage: `url("../../content/blog${node.fields.slug}${node.frontmatter.pic}.jpeg")`,
        //       }}>

  // useEffect(() => {

  // });

//   const mntgl = () => {
//     console.log ('sexi sexi');
//     document.body.classList.toggle("menu-open");
//   }

// function mntglo() {
//     document.getElementById(isid).classList.toggle(menu-open);
//     document.body.classList.toggle("menu-open")
//   }



        )
    }

    export default Projects